const filterAdapters = {
  billing_cycle_end_date_from: {
    path: 'invoice_details',
    field: 'invoice_billing_cycle_end_date'
  },
  billing_cycle_end_date_to: {
    path: 'invoice_details',
    field: 'invoice_billing_cycle_end_date'
  },
  date_range: {
    path: 'invoice_details',
    field: 'billing_cycle_date_range'
  },
  business_unit: {
    path: 'invoice_details__work_order',
    field: 'wo_org_unit_name'
  },
  job_category: {
    path: 'invoice_details',
    field: 'job_category'
  },
  invoice_status: {
    path: 'invoice_details',
    field: 'line_item_status'
  },
  billing_cycle_end_date: {
    field: 'invoice_billing_cycle_end_date',
    path: 'invoice_details'
  },
  billing_cycle_month: {
    path: '__calculated__',
    field: '9995c69b-e777-45a7-90e5-63239f523f55'
  },
  resource_manager: {
    field: 'resource_manager_name',
    path: 'invoice_details'
  },
  vendor: {
    field: 'vendor_name',
    path: 'invoice_details'
  },
  location: {
    field: 'work_location_name',
    path: 'invoice_details'
  }
}

export default filterAdapters
